import { useEffect, useState } from 'react';
import {
    S3Client,
    // This command supersedes the ListObjectsCommand and is the recommended way to list objects.
    ListObjectsV2Command,
} from "@aws-sdk/client-s3";

const Admin = () => {
    const [objects, setObjects] = useState([]);

    useEffect(() => {
        const client = new S3Client({
            region: process.env.REACT_APP_AWS_REGION,
            credentials: {
                accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
                secretAccessKey: process.env.REACT_APP_AWS_ACCESS_KEY
            }
        });

        const listBuckets = async () => {
            const command = new ListObjectsV2Command({
                Bucket: process.env.REACT_APP_AWS_BUCKET,
                MaxKeys: 50, // default = 1000
            });

            try {
                let isTruncated = true;

                console.log("Your bucket contains the following objects:\n");
                let contents = "";

                while (isTruncated) {
                    const {Contents, IsTruncated, NextContinuationToken} =
                        await client.send(command);
                    console.log('contents', Contents);
                    const contentsList = Contents.map((c) => ` • ${c.Key}`).join("\n");
                    setObjects(Contents);
                    contents += contentsList + "\n";
                    isTruncated = IsTruncated;
                    command.input.ContinuationToken = NextContinuationToken;
                }
                console.log(contents);
            } catch (err) {
                console.error(err);
            }
        };
        listBuckets();
    }, []);

    return (
        <div>
            <h2>Media in Bucket</h2>
            <ul>
                {objects.map(obj => (
                    <li key={obj.Key}>
                        {obj.Key}
                        {/*<button onClick={() => deleteObject(obj.Key)}>Delete</button>*/}
                    </li>
                ))}
            </ul>
            <image src="https://allison-nocita-mt.s3.us-west-1.amazonaws.com/headshot.png" />
        </div>
    );
}

export default Admin;


// access key
// AKIAVD2RBG5KS3TNBJ6L
// secret access key
// V9qlT2u6T9d8XE9M8OZo7c7nO3tCjD1LGV641uVy



// const deleteObject = async (key) => {
//     try {
//         await s3.deleteObject({ Bucket: 'your-bucket-name', Key: key }).promise();
//         setObjects(objects.filter(obj => obj.Key !== key));
//     } catch (error) {
//         console.error('Error deleting object:', error);
//     }
// };

